import { useState } from 'react'
import {
  Badge,
  Button,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Text,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react'

import { Plus } from 'components/icons'
import { MaskedInput } from 'components/dataEntry'
import { cepMask } from 'utils/masks'
import { CUSTOM_FORM_KIND_NAME } from 'components/tools/CustomForm/constants'
import { useGoogleGeolocation } from 'hooks/useGoogleGeolocation'
import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormSingleUploadQuestion from '../../../components/CustomFormViewerQuestion/components/CustomFormViewerQuestionSelection/components/CustomFormSingleUploadQuestion'
import CustomFormViewerQuestionSelection from '../../../components/CustomFormViewerQuestion/components/CustomFormViewerQuestionSelection'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function DependentesDoAGSUS() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch, register, setValue } = formMethods
  const [visibleDependent2, setVisibleDependent2] = useState(false)
  const [visibleDependent3, setVisibleDependent3] = useState(false)
  const [visibleDependent4, setVisibleDependent4] = useState(false)
  const { getGoogleAddressByIncompleteAddress } = useGoogleGeolocation()

  if (!questions) return null

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const seuExameAdmissionalFoiRealizadoPelaClinicaCredenciadaOuParticular = watch
    ? watch(
        `form_answers.${titleForQuestion['Seu exame admissional foi realizado pela Clínica credenciada ou particular?']}`
      )
    : undefined
  const possuiContaCorrenteOuContaSalarioNoBancoDoBrasil = watch
    ? watch(`form_answers.${titleForQuestion['Possui conta corrente ou conta salário no Banco do Brasil?']}`)
    : undefined

  const possuiChavePIXVinculadaAoCPF = watch
    ? watch(`form_answers.${titleForQuestion['Possui chave PIX vinculada ao CPF?']}`)
    : undefined

  const possuiCTPSDigital = watch ? watch(`form_answers.${titleForQuestion['Possui CTPS Digital?']}`) : undefined

  const possuiDependente = watch ? watch(`form_answers.${titleForQuestion['Possui dependente?']}`) : undefined

  async function getCEPInfo(cep: string) {
    const response = await getGoogleAddressByIncompleteAddress(cep)
    if (response) {
      const estadosMap: any = {
        Acre: 'AC',
        Alagoas: 'AL',
        Amapá: 'AP',
        Amazonas: 'AM',
        Bahia: 'BA',
        Ceará: 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        Goiás: 'GO',
        Maranhão: 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        Pará: 'PA',
        Paraíba: 'PB',
        Paraná: 'PR',
        Pernambuco: 'PE',
        Piauí: 'PI',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        Rondônia: 'RO',
        Roraima: 'RR',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        Sergipe: 'SE',
        Tocantins: 'TO',
      }

      setValue(`form_answers.${titleForQuestion['Endereço']}`, response.street)
      setValue(`form_answers.${titleForQuestion['Bairro']}`, response.neighbourhood)
      setValue(`form_answers.${titleForQuestion['Tipo de logradouro']}`, response.street.split(' ')[0])
      const sigla = estadosMap[response?.state]
      setValue(`form_answers.${titleForQuestion['Estado']}`, `${response?.state} - ${sigla}`)
      // setValue(`form_answers.${titleForQuestion['Estado']}`, response?.state)
      setValue(`form_answers.${titleForQuestion['Cidade']}`, response?.city)
    }
  }

  return (
    <Flex bg="transparent" flexDir="column" gap={2}>
      {questions.map((question, index) => {
        const questionKey = `form_answers.${String(question.slug)}`
        const questionAboutDependent = question.title?.includes('Dependente')
        const match = question.title?.match(/Dependente (\d+) -/)
        let number = null

        if (questionAboutDependent) {
          if (match) {
            number = parseInt(match[1], 10)
          }
        }

        if (number == 1 && possuiDependente != 'Sim') {
          return <></>
        }

        if (number == 2 && !visibleDependent2) {
          if (question.title == 'Dependente 2 - Nome completo' && possuiDependente == 'Sim') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent2(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar dependente 2
              </Button>
            )
          } else {
            return <></>
          }
        }

        if (number == 3 && !visibleDependent3) {
          if (question.title == 'Dependente 3 - Nome completo' && visibleDependent2 && possuiDependente == 'Sim') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent3(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar dependente 3
              </Button>
            )
          } else {
            return <></>
          }
        }

        if (number == 4 && !visibleDependent4) {
          if (question.title == 'Dependente 4 - Nome completo' && visibleDependent3 && possuiDependente == 'Sim') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent4(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar dependente 4
              </Button>
            )
          } else {
            return <></>
          }
        }

        //QUESTÃO 9
        if (question.title == 'Campo de upload para Recibo de Pagamento') {
          if (seuExameAdmissionalFoiRealizadoPelaClinicaCredenciadaOuParticular == 'Particular') {
            return (
              <Flex key={index} bg="bgContent" rounded="md" p={2}>
                <FormControl gap={2} isRequired={true}>
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="borderColor"
                    pb={2}
                    mb={2}
                  >
                    <Badge>{CUSTOM_FORM_KIND_NAME[question?.kind || 'Desconhecido']}</Badge>
                    <Text variant="secondary">
                      <Text as="span">{Number(index) + 1}</Text>
                      <Text as="span">/{questions?.length}</Text>
                    </Text>
                  </Flex>
                  <FormLabel mb={question?.description ? 0 : 2}>{question?.title || 'Questão sem título'}</FormLabel>
                  {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
                  <CustomFormSingleUploadQuestion
                    questionKey={questionKey}
                    formMethods={formMethods}
                    question={question}
                  />
                </FormControl>
              </Flex>
            )
          } else {
            return <></>
          }
        }

        //QUESTÃO 11
        if (question.title == 'Possui chave PIX vinculada ao CPF?') {
          return (
            <Flex key={index} bg="bgContent" rounded="md" p={2} flexDir="column">
              <FormControl gap={2} isRequired={true}>
                <Flex
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid"
                  borderColor="borderColor"
                  pb={2}
                  mb={2}
                >
                  <Badge>{CUSTOM_FORM_KIND_NAME[question?.kind || 'Desconhecido']}</Badge>
                  <Text variant="secondary">
                    <Text as="span">{Number(index) + 1}</Text>
                    <Text as="span">/{questions?.length}</Text>
                  </Text>
                </Flex>
                <FormLabel mb={question?.description ? 0 : 2}>{question?.title || 'Questão sem título'}</FormLabel>
                {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
                <CustomFormViewerQuestionSelection question={question} disabled={false} />
              </FormControl>
              {possuiChavePIXVinculadaAoCPF == 'Não' && (
                <Alert status="warning">
                  <AlertIcon />
                  <AlertDescription>
                    Obs: Caso você ainda não tenha uma chave PIX cadastrada em seu CPF, será necessário realizar o
                    cadastro, pois os pagamentos durante os três primeiros meses serão efetuados por meio dessa
                    modalidade
                  </AlertDescription>
                </Alert>
              )}
            </Flex>
          )
        }

        //QUESTÃO 12
        if (question.title == 'Gostaria que a Agência providencie a abertura de uma conta salário para você?') {
          if (possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Não') {
            return (
              <Flex key={index} bg="bgContent" rounded="md" p={2} flexDir="column">
                <FormControl gap={2} isRequired={true}>
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="borderColor"
                    pb={2}
                    mb={2}
                  >
                    <Badge>{CUSTOM_FORM_KIND_NAME[question?.kind || 'Desconhecido']}</Badge>
                    <Text variant="secondary">
                      <Text as="span">{Number(index) + 1}</Text>
                      <Text as="span">/{questions?.length}</Text>
                    </Text>
                  </Flex>
                  <FormLabel mb={question?.description ? 0 : 2}>{question?.title || 'Questão sem título'}</FormLabel>
                  {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
                  <CustomFormViewerQuestionSelection question={question} disabled={false} />
                </FormControl>
                {possuiChavePIXVinculadaAoCPF == 'Não' && (
                  <Alert status="warning">
                    <AlertIcon />
                    <AlertDescription>
                      Obs: Caso você ainda não tenha uma chave PIX cadastrada em seu CPF, será necessário realizar o
                      cadastro, pois os pagamentos durante os três primeiros meses serão efetuados por meio dessa
                      modalidade
                    </AlertDescription>
                  </Alert>
                )}
              </Flex>
            )
          } else {
            return <></>
          }
        }

        //QUESTÃO 12/13/14/15
        if (question.title == 'Agência' || question.title == 'Dígito' || question.title == 'Conta') {
          if (
            possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Conta Corrente' ||
            possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Conta Salário'
          ) {
            return (
              <Flex key={index} bg="bgContent" rounded="md" p={2}>
                <FormControl gap={2} isRequired={true}>
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="borderColor"
                    pb={2}
                    mb={2}
                  >
                    <Badge>{CUSTOM_FORM_KIND_NAME[question?.kind || 'Desconhecido']}</Badge>
                    <Text variant="secondary">
                      <Text as="span">{Number(index) + 1}</Text>
                      <Text as="span">/{questions?.length}</Text>
                    </Text>
                  </Flex>
                  <FormLabel mb={question?.description ? 0 : 2}>{question?.title || 'Questão sem título'}</FormLabel>
                  {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
                  <Input
                    isDisabled={false}
                    type="number"
                    inputMode="numeric"
                    placeholder={question?.placeholder}
                    {...(register ? { ...register(`form_answers.${String(question.slug)}`) } : {})}
                  />
                </FormControl>
              </Flex>
            )
          } else {
            return <></>
          }
        }

        //QUESTÃO 21
        if (question.title == 'CEP') {
          return (
            <Flex key={index} bg="bgContent" rounded="md" p={2}>
              <FormControl gap={2} isRequired={true}>
                <Flex
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid"
                  borderColor="borderColor"
                  pb={2}
                  mb={2}
                >
                  <Badge>{'CEP'}</Badge>
                  <Text variant="secondary">
                    <Text as="span">{Number(index) + 1}</Text>
                    <Text as="span">/{questions?.length}</Text>
                  </Text>
                </Flex>
                <FormLabel mb={question?.description ? 0 : 2}>{question?.title || 'Questão sem título'}</FormLabel>
                {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
                <MaskedInput
                  isDisabled={false}
                  placeholder="00000-000"
                  mask={cepMask}
                  {...(register
                    ? {
                        ...(register
                          ? {
                              ...register(`form_answers.${String(question.slug)}`, {
                                onBlur: (e: any) => {
                                  getCEPInfo(e.target.value)
                                },
                              }),
                            }
                          : {}),
                      }
                    : {})}
                />
              </FormControl>
            </Flex>
          )
        }

        //QUESTÃO 43/44/45/46
        if (
          question.title == 'CTPS - Número' ||
          question.title == 'CTPS - UF' ||
          question.title == 'CTPS - Data de emissão' ||
          question.title == 'CTPS - Série'
        ) {
          if (possuiCTPSDigital == 'Não') {
            return (
              <Flex key={index} bg="bgContent" rounded="md" p={2}>
                <FormControl gap={2} isRequired={true}>
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="borderColor"
                    pb={2}
                    mb={2}
                  >
                    <Badge>{CUSTOM_FORM_KIND_NAME[question?.kind || 'Desconhecido']}</Badge>
                    <Text variant="secondary">
                      <Text as="span">{Number(index) + 1}</Text>
                      <Text as="span">/{questions?.length}</Text>
                    </Text>
                  </Flex>
                  <FormLabel mb={question?.description ? 0 : 2}>{question?.title || 'Questão sem título'}</FormLabel>
                  {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
                  <CustomFormViewerQuestionSelection question={question} disabled={false} />
                </FormControl>
              </Flex>
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
